import { render, staticRenderFns } from "./LawyerFormPage.vue?vue&type=template&id=3ff082d2&"
import script from "./LawyerFormPage.vue?vue&type=script&lang=js&"
export * from "./LawyerFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports